import { render, staticRenderFns } from "./ViewAuditDataCollectionManagementAndAnalysis.vue?vue&type=template&id=0a94f470&scoped=true"
import script from "./ViewAuditDataCollectionManagementAndAnalysis.vue?vue&type=script&lang=js"
export * from "./ViewAuditDataCollectionManagementAndAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a94f470",
  null
  
)

export default component.exports